/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import {createSelector} from 'reselect';
import {ApplicationState} from '@/types/redux';

export const selectAuthenticated     = ({login: {authenticated}}: ApplicationState) => authenticated;
export const selectHasPreviewFeature = ({login: {hasPreviewFeature}}: ApplicationState) => hasPreviewFeature;
export const selectIsLoggingOut      = ({login: {isAuthenticating}}: ApplicationState) => isAuthenticating;
export const loginErrorMessage       = ({login: {loginErrorMessage}}: ApplicationState) => loginErrorMessage;

export const isAuthenticatedSelector = createSelector(selectAuthenticated,
  (authenticated: boolean): boolean => authenticated
);

export const hasPreviewFeatureSelector =
  createSelector([selectHasPreviewFeature], (hasPreviewFeature) => (hasPreviewFeature));

export const isLoggingOutSelector      =
  createSelector([selectIsLoggingOut], (isLoggingOut) => (isLoggingOut));

export const loginErrorMessageSelector = createSelector([loginErrorMessage], (loginError) => (loginError));
